import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Mujeres casadas con hijos que sienten que viven en "piloto automático".', 'Esposas que extrañan sentirse deseadas y admiradas por sus parejas.', 'Mujeres que sienten que han perdido su identidad y brillo personal.'];
  const notForWho = ['Personas que buscan soluciones mágicas sin querer reflexionar sobre sus emociones.', 'Mujeres que no están en una relación de pareja actualmente.'];
  return <section id="audience" className="py-24 px-4 md:px-8 bg-cream relative overflow-hidden" data-id="element-1">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-2">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-0 relative" data-id="element-3">
          {/* Animated Divider Line */}
          <motion.div initial={{
          opacity: 0,
          scaleY: 0
        }} whileInView={{
          opacity: 1,
          scaleY: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} className="hidden lg:block absolute left-1/2 top-10 bottom-10 w-[1px] bg-gradient-to-b from-transparent via-gold/40 to-transparent origin-top -translate-x-1/2" data-id="element-4" />

          {/* Para ti si */}
          <div className="flex-1 lg:pr-16" data-id="element-5">
            <FadeIn direction="right" className="bg-gradient-to-br from-white to-rose-light/30 rounded-[2.5rem] shadow-xl border border-rose/20 h-full overflow-hidden" data-id="element-6">
              {/* Empowering Image */}
              <img src="https://images.unsplash.com/photo-1509967419530-da38b4704bc6?w=600&q=80" alt="Mujer segura y radiante sonriendo con confianza" className="w-full h-44 md:h-52 object-cover object-top" data-id="element-7" />

              <div className="p-8 md:p-12" data-id="element-8">
                <h3 className="text-3xl font-serif text-burgundy-dark mb-10 flex items-center gap-4" data-id="element-9">
                  <span className="w-10 h-[2px] bg-gold rounded-full" data-id="element-10"></span>
                  Para ti si...
                </h3>
                <ul className="space-y-8" data-id="element-11">
                  {forWho.map((text, idx) => <li key={idx} className="flex items-start gap-5" data-id="element-12">
                      <motion.div initial={{
                    scale: 0,
                    rotate: -45
                  }} whileInView={{
                    scale: 1,
                    rotate: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    type: 'spring',
                    delay: 0.2 + idx * 0.15
                  }} className="mt-1 bg-green-100 text-green-700 p-2 rounded-full shrink-0 shadow-sm" data-id="element-13">
                        <CheckIcon className="w-5 h-5" data-id="element-14" />
                      </motion.div>
                      <span className="text-charcoal text-lg leading-relaxed" data-id="element-15">
                        {text}
                      </span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>
          </div>

          {/* No es para ti si */}
          <div className="flex-1 lg:pl-16" data-id="element-16">
            <FadeIn direction="left" delay={0.2} className="bg-cream-dark/20 p-8 md:p-12 rounded-[2.5rem] border border-cream-dark h-full backdrop-blur-sm" data-id="element-17">
              <h3 className="text-3xl font-serif text-charcoal-light mb-10 flex items-center gap-4 opacity-80" data-id="element-18">
                <span className="w-10 h-[2px] bg-charcoal-light/30 rounded-full" data-id="element-19"></span>
                No es para ti si...
              </h3>
              <ul className="space-y-8" data-id="element-20">
                {notForWho.map((text, idx) => <li key={idx} className="flex items-start gap-5 opacity-70 hover:opacity-100 transition-opacity duration-300" data-id="element-21">
                    <motion.div initial={{
                  scale: 0,
                  rotate: 45
                }} whileInView={{
                  scale: 1,
                  rotate: 0
                }} viewport={{
                  once: true
                }} transition={{
                  type: 'spring',
                  delay: 0.4 + idx * 0.15
                }} className="mt-1 bg-gray-200 text-gray-500 p-2 rounded-full shrink-0" data-id="element-22">
                      <XIcon className="w-5 h-5" data-id="element-23" />
                    </motion.div>
                    <span className="text-charcoal-light text-lg leading-relaxed" data-id="element-24">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}